import { AjaxError } from '../util'

/**
 * Uses a fetch request to the get the municipalities.
 * @param {(string|null)} countyId
 * @returns {Promise<object>}
 */
export default async function getMunicipalityMapData() {
    let url = window.__appData__.rest.endpoints.municipalityMap

    const headers = new Headers({
        'Content-Type': 'application/json',
        'X-WP-Nonce': window.__appData__.rest.nonce,
    })

    const response = await fetch(url, {
        headers,
    })

    if (!response.ok) {
        throw new AjaxError(`Fetching data from ${url} has failed`, response)
    }

    return response.json()
}



// WEBPACK FOOTER //
// ./scripts/api/endpoints/getMunicipalityMapData.js